
export class InvoiceDetail {
  id: number;
  invoiceHeaderId: number;
  economicActId: number;
}
